import   React                   ,
       { useState                }  from 'react';

import   classNames                 from 'classnames';

import   styles                     from './ProductCategoryManager.module.scss';

import   ProductCategoryCreation    from './ProductCategoryCreation';
import   ProductCategoryList        from './ProductCategoryList';

import { ProductCategory }          from '../../../dataTypes/productManagment/types';

export interface ProductCategoryManagerProps {
  onCategoryCreated?: (createdCategory: ProductCategory) => void;
  /** Si fourni, affiche le bouton de retour "Produits" en haut à droite. */
  onBackToProducts?: () => void;
}

export const ProductCategoryManager = ({ onCategoryCreated, onBackToProducts }: ProductCategoryManagerProps = {}) => {

  const [ refreshList            , setRefreshList            ] = useState<boolean>(false);
  const [ productCategoriesCount , setProductCategoriesCount ] = useState<number>(0);

  const handleProductCategoryCreation = (createdCategory?: ProductCategory) => {

	console.log ( "handleProductCategoryCreation")
    setRefreshList((prevState) => !prevState);
    if (createdCategory && onCategoryCreated) { onCategoryCreated(createdCategory); }
  };

  const handleProductCategoryDeletion = () => {
	  
	console.log ( "handleProductCategoryDeletion")  
    setRefreshList((prevState) => !prevState);
  };

  const handleProductCategoriesCount = (count: number) => {
	  
	console.log ( "handleProductCategoriesCount")  
    setProductCategoriesCount(count);
  };

  return (
    <div className={classNames(styles.root)}>

      <div className={classNames(styles.pageHeader)}>
        <div className={classNames(styles.pageHeaderText)}>
          <h1 className={classNames(styles.pageTitle)}>Catégories de produits</h1>
          <p className={classNames(styles.pageSubtitle)}>Organisez et gérez les catégories de votre boutique.</p>
        </div>
        {
          onBackToProducts &&
          <button className={classNames(styles.btn, styles.btnPrimary)}
                  onClick={onBackToProducts}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
              <line x1="19" y1="12" x2="5" y2="12"/>
              <polyline points="12 19 5 12 12 5"/>
            </svg>
            Produits
          </button>
        }
      </div>

      <div className={classNames(styles.contain)}>
        <div className={classNames(styles.creationPart)}>
          <ProductCategoryCreation onCreate      = {handleProductCategoryCreation}
                                   numCategories = {productCategoriesCount} />
        </div>
        <div className={classNames(styles.listPart)}>
          <ProductCategoryList refresh             = {refreshList}
                               onCategoriesFetched = {handleProductCategoriesCount}
                               onDelete            = {handleProductCategoryDeletion}/>
        </div>
      </div>
    </div>
  );
};

export default ProductCategoryManager;
